import React from 'react'
import { BrowserRouter, Route, Switch } from 'react-router-dom'
import axios from 'axios'
import { version } from '../package.json'
// Import Components

import Layout from './components/Layout'

// Import Pages

import Home from './pages/Home'
import Edit from './pages/EditPage'
import EditUser from './pages/EditUser'
import PagesList from './pages/PagesList'
import UsersList from './pages/UsersList'
import Content from './pages/Content'
import FileGalleryPage from './pages/FileGalleryPage'
import SettingsPage from './pages/SettingsPage'
import FileReplacePage from './pages/FileReplacePage'
import LoginContainer from './pages/Login'
import SamlLogin from './pages/SamlLogin'
import CrossStorage from './pages/CrossStorage'
import PrivateRoute from './components/PrivateRoute'
import NotFound from './pages/NotFound'
import { getUser } from './api/users'

// set version number in html element
const el = document.querySelector('html')
el.setAttribute('data-ui-version', version)

class App extends React.Component {
  constructor (props, context) {
    super(props, context)

    let user = localStorage.getItem('user')
    user = user && JSON.parse(user)

    this.state = {
      user
    }

    axios.defaults.headers.common['x-access-token'] = localStorage.getItem('token')

    axios.interceptors.response.use((response) => {
      return response
    }, this.requestErrorHandler)
  }

  componentDidMount = async () => {
    if (this.state.user) {
      await getUser(this.state.user.id)
    }
  }

  requestErrorHandler = (error) => {
    if (error.response && error.response.status === 403) {
      this.logout()
    }

    // Send server response instead of generic JS error
    return Promise.reject(error.response || error)
  }

  logout = () => {
    localStorage.removeItem('user')
    localStorage.removeItem('token')
    this.setState({ user: null })
  }

  login = (user, token) => {
    localStorage.setItem('user', JSON.stringify(user))
    localStorage.setItem('token', token)
    axios.defaults.headers.common['x-access-token'] = token
    this.setState({ user: user })
  }

  render () {
    return (
      <BrowserRouter>
        <Layout user={this.state.user} onLogout={this.logout}>
          <Switch>
            <PrivateRoute user={this.state.user} path='/' exact component={Home} />
            <PrivateRoute user={this.state.user} path='/settings' exact component={SettingsPage} />
            <PrivateRoute user={this.state.user} path='/users/:paginationPage?' exact component={UsersList} />
            <PrivateRoute user={this.state.user} path='/users/edit/new' exact component={EditUser} />
            <PrivateRoute user={this.state.user} path='/users/edit/:userId' exact component={EditUser} />
            <PrivateRoute user={this.state.user} path='/pages/:paginationPage?' exact component={PagesList} />
            <PrivateRoute user={this.state.user} path='/recent-pages/:paginationPage?' exact component={PagesList} />
            <PrivateRoute user={this.state.user} path='/pages/edit/:pageId' component={Edit} />
            <PrivateRoute user={this.state.user} path='/files/:paginationPage?' exact component={FileGalleryPage} />
            <PrivateRoute user={this.state.user} path='/files/:fileId/replace' exact component={FileReplacePage} />
            <PrivateRoute user={this.state.user} path='/images/:paginationPage?' exact component={FileGalleryPage} />
            <PrivateRoute user={this.state.user} path='/documents/:paginationPage?' exact component={FileGalleryPage} />
            <Route path='/login' exact render={(props) => (<LoginContainer onLogin={this.login} {...props} />)} />
            <Route path='/saml/login' exact render={(props) => (<SamlLogin onLogin={this.login} {...props} />)} />
            <PrivateRoute user={this.state.user} path='/content' component={Content} />
            <Route path='/storage' exact component={CrossStorage} />
            <Route component={NotFound} />
          </Switch>
        </Layout>
      </BrowserRouter>
    )
  }
}

export default App



// WEBPACK FOOTER //
// ./src/App.js